import * as React from 'react';
import { useState } from 'react';
import { TextField, Typography } from '@material-ui/core';
import styled from 'styled-components';
import NumberFormat, { NumberFormatValues } from 'react-number-format';
import { BackOrderOfferCreditSubscriptionType, ClosetUserCount } from 'types/api/backorder';
import Button from 'components/common/Button';
import CreditCalculationModal from 'components/backorder/modal/CreditCalculationModal';
import { getClosetUserCount } from 'api/backorder';

interface Props {
  groupId: string;
  subscriptionPlan: BackOrderOfferCreditSubscriptionType;
  subscriptionTerm: [string, string];
  offerCredit: number;
  onChangeOfferCredit: (credit: number) => void;
}

const OfferCredits = ({
  groupId,
  subscriptionPlan,
  subscriptionTerm,
  offerCredit,
  onChangeOfferCredit,
}: Props) => {
  const [creditCalculationModalVisibility, setCreditCalculationModalVisibility] =
    useState<boolean>(false);
  const [closetUserCount, setClosetUserCount] = useState<ClosetUserCount | null>(null);

  const onClickCreditCalculation = async (): Promise<void> => {
    setCreditCalculationModalVisibility(true);
    if (closetUserCount !== null) return;
    const res = await getClosetUserCount({ groupId });
    if (!res) return;
    setClosetUserCount(res);
  };

  return (
    <>
      <OfferCreditsBlock>
        <TextFieldWrapper>
          <NumberFormat
            value={offerCredit}
            customInput={TextField}
            thousandSeparator
            decimalScale={2}
            allowNegative={false}
            onValueChange={(value: NumberFormatValues) => {
              if (!value.floatValue) return;
              onChangeOfferCredit(value.floatValue);
            }}
            onBlur={({ target: { value } }: React.FocusEvent<HTMLInputElement>) => {
              const floatNumber = Number(value.replace(/,/gi, ''));
              onChangeOfferCredit(Math.floor(floatNumber * 100) / 100);
            }}
          />
          <Typography variant={'body2'} color={'textPrimary'}>
            Credits
          </Typography>
        </TextFieldWrapper>
        <Button variant="contained" size="small" color="primary" onClick={onClickCreditCalculation}>
          Credit Calculation
        </Button>
      </OfferCreditsBlock>
      {creditCalculationModalVisibility && (
        <CreditCalculationModal
          subscriptionPlan={subscriptionPlan}
          subscriptionTerm={subscriptionTerm}
          onChangeOfferCredit={onChangeOfferCredit}
          closetUserCount={closetUserCount}
          onClose={() => setCreditCalculationModalVisibility(false)}
        />
      )}
    </>
  );
};

export default OfferCredits;

const TextFieldWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing(2)}px;

  .MuiInputBase-input {
    text-align: right;
    padding-right: 3px;
    padding-left: 11px;
  }
`;

const OfferCreditsBlock = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: ${props => props.theme.spacing(5)}px;
`;
